/**
 * @generated SignedSource<<7d21dec31d2b5e4e7378c4ddf12f3680>>
 * @relayHash b4bb4da349d8fe7b41a55b67a641db72
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 913fbb0382cf9cf095f853f6b818d4e8a47f615cd232275e0519fc5ae4eb57f1

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesVersionProgressQuery$variables = {
  isDevopsFeatureDisabledInFedRamp: boolean;
  versionAri: string;
};
export type ui_softwareReleasesVersionProgressQuery$data = {
  readonly jira: {
    readonly version: {
      readonly " $fragmentSpreads": FragmentRefs<"ui_versionProgress_VersionProgress">;
    };
  };
};
export type ui_softwareReleasesVersionProgressQuery = {
  response: ui_softwareReleasesVersionProgressQuery$data;
  variables: ui_softwareReleasesVersionProgressQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDevopsFeatureDisabledInFedRamp"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "versionAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = [
  {
    "kind": "ScalarField",
    "name": "totalCount"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v7 = [
  {
    "kind": "ScalarField",
    "name": "url"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionProgressQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "ui_versionProgress_VersionProgress"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.version"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ui_softwareReleasesVersionProgressQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "doneIssuesRedesignTemp",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filters",
                        "value": {
                          "statusCategories": [
                            "DONE"
                          ]
                        }
                      }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                  },
                  {
                    "alias": "inProgressIssuesRedesignTemp",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filters",
                        "value": {
                          "statusCategories": [
                            "IN_PROGRESS"
                          ]
                        }
                      }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                  },
                  {
                    "alias": "todoIssuesRedesignTemp",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filters",
                        "value": {
                          "statusCategories": [
                            "TODO"
                          ]
                        }
                      }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                  },
                  {
                    "concreteType": "JiraVersionWarningConfig",
                    "kind": "LinkedField",
                    "name": "warningConfig",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "failingBuild"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "openPullRequest"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "openReview"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "unreviewedCode"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "warningsCount"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "collapsedUis"
                  },
                  (v5/*: any*/),
                  {
                    "condition": "isDevopsFeatureDisabledInFedRamp",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "args": (v6/*: any*/),
                        "concreteType": "JiraVersionRelatedWorkV2Connection",
                        "kind": "LinkedField",
                        "name": "relatedWorkV2",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraVersionRelatedWorkV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v7/*: any*/),
                                    "type": "JiraVersionRelatedWorkGenericLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v7/*: any*/),
                                    "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "cursor"
                              }
                            ]
                          },
                          {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "endCursor"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                              }
                            ]
                          }
                        ],
                        "storageKey": "relatedWorkV2(first:100)"
                      },
                      {
                        "args": (v6/*: any*/),
                        "handle": "connection",
                        "key": "version_relatedWorkV2",
                        "kind": "LinkedHandle",
                        "name": "relatedWorkV2"
                      }
                    ]
                  }
                ],
                "type": "JiraVersion"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "913fbb0382cf9cf095f853f6b818d4e8a47f615cd232275e0519fc5ae4eb57f1",
    "metadata": {},
    "name": "ui_softwareReleasesVersionProgressQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "67f2e201e7debdeea53f08cb0f8bb7b1";

export default node;
